import React from "react";
import classNames from "classnames";

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
}

const Spinner = ({ size = 18, className, ...props }: SpinnerProps) => (
  <div {...props} className={classNames("flex items-center justify-center w-full max-h-full", className)}>
    <svg
      viewBox="20 20 40 40"
      className={"text-black origin-center animate-spinner"}
      width={`${size}px`}
      height={`${size}px`}
    >
      <circle
        cx="40"
        cy="40"
        r="18"
        stroke="currentColor"
        strokeWidth={3}
        strokeDasharray={50}
        strokeLinecap="round"
        fill="none"
        className={"stroke"}
      />
    </svg>
  </div>
);

export default Spinner;